import { useQuery } from '@tanstack/react-query';
import { IProjectLimits } from 'types/limits';
import { get } from './api';
import API_ROUTES from './routes';

const getProjectLimits = async () => {
	const res = await get<IProjectLimits>(API_ROUTES.v1.projectLimits, {});
	return res.data;
};

export const useProjectLimits = (projectId: string) =>
	useQuery(['project_limits', projectId], getProjectLimits, {
		staleTime: 100000,
		refetchOnWindowFocus: false
	});
